/** Width of the sidebar */
export const SIDENAV_WIDTH = 254

/**
 * Width of the contracted icon rail.
 *
 * Tailwind cannot interpolate this, so two class literals restate it and must change with it:
 * `lg:w-[calc(100%-48px)]` on the dashboard content column (DashboardLayout) and `lg:left-12` on
 * the sidebar-offset overlay (BottomSheet).
 */
export const SIDENAV_CONTRACTED_WIDTH = 48

/** Default URL for the Paxton logo icon (square version) */
export const PAXTON_LOGO_ICON_URL = '/images/paxton-web-square-120.png'

/** The Paxton diamond mark shown in the contracted rail's header */
export const PAXTON_LOGO_MARK_URL = '/images/paxton-logo-mark.svg'
